import axiosInstance from "../Axios-Config/Axios-Config";
import Konsole from "../utils/konsole/Konsole";
const GetAllStore = async ({ longitude, latitude,}: { longitude: any; latitude: any;}) => {
  try {
    const { data }: any = await axiosInstance.get(`store/all/data/list?longitude=${longitude}&lattitude=${latitude}`);

    // Konsole.log("resData",data)
    if (data?.success) {
      return {
        success: true,
        all_Store: data?.all_Store,
        domain_details: data?.domain_details,
      };
    } else {
      return {
        success: false,
        all_Store: [],
        domain_details: {},
      };
    }
  } catch (error: any) {
    Konsole.log('error',error)
    return {
      success: false,
      all_Store: [],
      domain_details: {},
    };
  }
};

export default GetAllStore;
